import { redirect, type RouteObject } from 'react-router-dom';

import { type ItemType, itemTypes } from '@/models/item/item';

export const itemRoute: RouteObject = {
  path: 'items',
  children: [
    {
      path: '',
      loader: () => redirect('item'),
    },
    ...itemTypes.map(
      (type: ItemType): RouteObject => ({
        path: type,
        loader: () => ({ type }),
        lazy: () => import('./items'),
      }),
    ),
  ],
};
